<template>
    <div>
        <router-view />
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'App',

        data () {
            return {
            }
        },

        methods: {
        },
    };
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
